<template>
  <section>
    <Header :indexData="indexData" :userInfo="userInfo" :keyword="keyword" :showNav="false"></Header>
    <div v-html="goodsList.content" style="text-align:center"></div>
    <Footer :indexData="indexData"></Footer>
  </section>
</template>

<script>
import Header from "../components/header";
import Footer from "../components/footer";
layui.use(["layer"], function() {
  layer = layui.layer;
});
export default {
  components: {
    Header,
    Footer
  },
  name: "jiesuan",
  data() {
    return {
      guid: sessionStorage.guid || "fece45ba9a843c1eb1b788d2a59d3e2a",
      keyword: "",
      indexData: {},
      userInfo: {},
      query: {},
      goodsList3:{},
      page: 1,
      goodsList: {}
    };
  },
  methods: {
    //  获取专区商品
    async getZhuanquGoods() {
      let goodsList = await await this.$fetch("index/detail", {
        body: Object.assign(this.query, { type:"content_topic"})
      });
      this.goodsList = goodsList;
    },
    // 改变当前页
    currentPage(e) {
      this.page = e;
      this.getZhuanquGoods();
    },
     // 最上面3个
    async getZhuanquGoods3() {
      let goodsList3 = await await this.$fetch("Shop/productlist", {
        body: Object.assign( { isresume:1, pagesize: 3 ,isspec:1})
      });
      this.goodsList3 = goodsList3;
    },
  },

  async mounted() {
    this.indexData = await this.$fetch("Index/indexdata");
    this.query = getParameterByName();
    this.getZhuanquGoods();
    // this.getZhuanquGoods3()
    if (sessionStorage.user) {
      this.userInfo = JSON.parse(sessionStorage.user);
    }
    $(".nav-service").hover(
      function() {
        $(this).find(".downmenu").slideDown("fast");
      },
      function() {
        $(this)
          .find(".downmenu")
          .stop()
          .slideUp("fast");
      }
    );
  }
};
</script>

  


<style lang='scss' scoped>
.zhuanquheader {
  position: relative;
  .banner {
    width: 100%;
    height: 880px;
    background: url("/static/images/zhuanqu_bg.png");
    background-size: 100% 100%;
  }
}

.goodsListPlu {
  background: #fff;
  position: absolute;
  z-index: 999;
  left: 50%;
  transform: translate(-50%, -0%);
  bottom: 0;
  .goodsItem {
    width: 400px;
    height: 450px;
    .goodsimg {
      width: 100%;
      height: 320px;
      img {
        width: 200px;
        height: 200px;
      }
    }
    .goodsinfo {
      width: 360px;
      height: 110px;
      background: rgba(255, 249, 240, 1);
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      margin: auto;
      .name {
        padding: 20px;
        box-sizing: border-box;
      }
      .price {
        text-align: center;
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(255, 33, 33, 1);
      }
    }
  }
}
.goodsList {
  background: #fff;
  flex-wrap: wrap;
  .goodsItem {
    width: 300px;
    height: 350px;
    margin-bottom: 20px;
    .goodsimg {
      width: 100%;
      // height: 150px;
      img {
        width: 180px;
        height: 180px;
      }
    }
    .goodsinfo {
      width: 260px;
      // height: 80px;
      background: rgba(255, 249, 240, 1);
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      margin: auto;
      .name {
        padding: 20px;
        box-sizing: border-box;
        text-align: center;
      }
      .price {
        text-align: center;
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(255, 33, 33, 1);
      }
    }
  }
}
.fenge {
  width: 100%;
  height: 222px;
  img {
    width: 414px;
    height: 83px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/zhuanqu.vue